export const FETCH_ALL_MISSIONS = 'spaceHub/api/FETCH_ALL_MISSIONS';
export const FETCH_ALL_ROCKETS = 'spaceHub/api/FETCH_ALL_ROCKETS';
export const FETCH_ALL_DRAGONS = 'spaceHub/api/FETCH_ALL_DRAGONS';

export const RESERVE_ROCKET = 'spaceHub/rockets/RESERVE_ROCKET';
export const CANCEL_RESERVATION = 'spaceHub/rockets/CANCEL_RESERVATION';
export const RESERVE_DRAGON = 'spaceHub/dragons/RESERVE_DRAGON';
export const CANCEL_RESERVE = 'spaceHub/dragons/CANCEL_RESERVATION';
export const RESERVE_MISSION = 'spaceHub/rockets/RESERVE_MISSION';
